import React, { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Auth";
import { fetchApi, range } from "../../../Funciones";
import { Button, InputGroup, FormControl, FormSelect, Pagination, Spinner, Table, Badge } from "react-bootstrap";
import { ChevronLeft, Gear, PlusLg, XLg } from "react-bootstrap-icons";
import { TagEditor } from "./Manager";
export const Home: React.FC = () => {
    let auth = useAuth();
    let nav = useNavigate();

    const [filtro, setFiltro] = useState("")
    const [listado, setListado] = useState<any>([])
    const [pagina, setPagina] = useState(0)
    const [porPagina, setPorPagina] = useState(localStorage.getItem("porPagina") ? parseInt(localStorage.getItem("porPagina") + "") : 10)
    const [cargando, setCargando] = useState(false)
    const [total, setTotal] = useState(0)

    var filtradas = listado;
    var paginas = range(1, Math.ceil(total / porPagina) + 1)

    const getData = async () => {
        setCargando(true)
        var data = await fetchApi(auth.user.token, "tag", {
            cmd: "search",
            s: filtro,
            p: pagina,
            pp: porPagina
        })
        setListado(data.listado)
        setTotal(data.total)
        setCargando(false)
    }

    useEffect(() => {
        return () => clearTimeout(timeRef.current!)
    }, [])

    const timeRef = useRef<any>(null)
    useEffect(() => {
        clearTimeout(timeRef.current!)
        timeRef.current = setTimeout(() => {
            getData()
        }, 300)
        // eslint-disable-next-line
    }, [filtro])

    useEffect(() => {
        if (auth.user) {
            clearTimeout(timeRef.current!)
            getData()
        }
        // eslint-disable-next-line
    }, [auth.user, pagina, porPagina])

    return <>
        <Button size="sm" variant="dark" onClick={() => { nav(-1) }} className="my-2"><ChevronLeft /> Volver</Button>
        <h4>Gestión de Etiquetas</h4>

        <div className="py-2">
            <TagEditor id={""} name={""} backgroundColor={""} fontColor={""} description="" callback={() => { getData() }}>
                <Button variant="outline-dark" className="d-inline-block">Agregar Etiqueta <PlusLg /></Button>
            </TagEditor>
            <div className="d-inline-block ms-4">
                <InputGroup>
                    <FormControl type="text" placeholder='Buscar' value={filtro} onChange={(ev) => setFiltro(ev.target.value)} />
                    <Button variant="outline-danger" onClick={() => setFiltro("")}><XLg /></Button>
                </InputGroup>
            </div>
            <FormSelect className="d-inline-block w-auto ms-4" title="Por Página" value={porPagina} onChange={(ev) => {
                setPagina(0)
                setPorPagina(parseInt(ev.target.value));
                localStorage.setItem("porPagina", ev.target.value)
            }}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
            </FormSelect>
            {total > porPagina && <div className="d-inline-block ms-4">
                <Pagination>
                    <Pagination.First onClick={() => setPagina(0)} />
                    {paginas.map(p => <Pagination.Item key={p} onClick={() => setPagina(p - 1)} active={pagina === p - 1}>{p}</Pagination.Item>)}
                    <Pagination.Last onClick={() => setPagina(paginas.length - 1)} />
                </Pagination>
            </div>}
            {cargando && <Spinner animation="border" size="sm" className="d-inline-block ms-4" />}
        </div>

        {listado && listado.length > 0 && <Table bordered hover striped size="sm" className="shadow w-auto">
            <thead>
                <tr>
                    <th className="text-center">ID</th>
                    <th className="text-center">Acciones</th>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th>Contenidos</th>
                </tr>
            </thead>
            <tbody>
                {filtradas.map((item: any, i: any) => <tr key={item.id}>
                    <td className="text-center" width={60}>{item.id}</td>
                    <td>
                        <TagEditor id={item.id} name={item.name} backgroundColor={item.backgroundColor} fontColor={item.fontColor} description={item.description} callback={() => getData()}>
                            <Button size="sm" variant="secondary" title="Editar"><Gear /></Button>
                        </TagEditor>
                        <Button size="sm" className="ms-1" variant="danger" title="Eliminar" disabled={parseInt(item.contenidos) !== 0}><XLg /></Button>
                    </td>
                    <td><Badge pill bg="" style={{ backgroundColor: item.backgroundColor, color: item.fontColor }}>{item.name}</Badge></td>
                    <td>{item.description}</td>
                    <td className="text-center">
                        {item.contenidos}
                    </td>
                </tr>)}
            </tbody>
        </Table>}
    </>
}